import api from '../api'

export function fetchGeoInfo() {
  	return (dispatch) => api.fetch('/geo-info')
	    .then((response) => {
		      dispatch({ type: 'FETCH_GEO_INFO_SUCCESS', response})
	    })
	    .catch((error) => {
			return error
		})
}
  
